import { useMutation, useQueryClient } from 'react-query';
import {
  likeAdaptedFictionEdition,
  type LikeAdaptedFictionEditionResponse,
  type LikeAdaptedFictionEditionBody
} from '../../services/commentsAndLikeService';
import { SCENE_QUERY_KEYS } from '../queryKeys';

export function useLikeAdaptedFictionEdition() {
  const queryClient = useQueryClient();
  return useMutation<
    LikeAdaptedFictionEditionResponse,
    Error,
    {
      adaptedFictionEditionId: string;
      body: LikeAdaptedFictionEditionBody;
    }
  >({
    mutationFn: ({ adaptedFictionEditionId, body }) =>
      likeAdaptedFictionEdition({ adaptedFictionEditionId, body }),
    onSuccess: (data, variables) => {
      const targetId = variables.adaptedFictionEditionId;

      queryClient.setQueriesData(SCENE_QUERY_KEYS.adaptedFictionPreviews, (oldPreviews) => {
        if (!oldPreviews) return oldPreviews;

        return {
          ...oldPreviews,
          pages: (
            oldPreviews as {
              pages: Array<
                Array<{ adaptedFictionEditionId: string; isLiked: boolean; likesCount: number }>
              >;
            }
          ).pages.map(
            (
              page: Array<{ adaptedFictionEditionId: string; isLiked: boolean; likesCount: number }>
            ) => {
              return page.map((post) => {
                if (post.adaptedFictionEditionId === targetId) {
                  return {
                    ...post,
                    isLiked: data.isLiked,
                    likesCount: data.likesCount
                  };
                }
                return post;
              });
            }
          )
        };
      });
    }
  });
}
